<template>
	<el-row class="container">
		<el-col :span="1">&nbsp;</el-col>
		<el-col :span="4">
			<div style="width: 200px;margin-top: 100px;">
				<div style="padding: 10px;">
					<h3>账户云豆余额</h3>
					<h4 style="font-size:24px;">{{user.balance}}</h4>
					<el-button type="primary" style="width:90%;" disabled="disabled">充值</el-button>
				</div>
			</div>
		</el-col>
		<el-col :span="6" class="header">
			<el-form style="text-align: right;">
				<el-form-item>
					<h3 style="text-align: left">商家云豆划拨</h3>
				</el-form-item>
				<el-form-item prop="input">
					<label>账号：</label>
					<el-input style="width: 250px;"
							  size="small"
							  placeholder="请输入账号"
							  clearable
							  v-model="input">
					</el-input>
				</el-form-item>
				<el-form-item>
					<label>账号：</label>
					<el-input style="width: 250px;"
							  size="small"
							  placeholder="账号"
							  v-model="business.account"
							  :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item>
					<label>账号昵称：</label>
					<el-input style="width: 250px;"
							  size="small"
							  placeholder="账号昵称"
							  v-model="business.nickname"
							  :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item>
						<label>手机号码：</label>
						<el-input style="width: 250px;"
								  size="small"
								  placeholder="手机号码"
								  v-model="business.phone"
								  :disabled="true">
						</el-input>

				</el-form-item>
				<el-form-item>
					<label>划拨数量：</label>
					<el-input style="width: 250px;"
							  size="small"
							  type="number"
							  min="1"
							  placeholder="划拨数量"
							  v-model="num">
					</el-input>
				</el-form-item>
				<el-form-item style="text-align: right;">
						<el-button type="primary" style="width:80%;" :disabled="transfer" @click.native.prevent="businessTransfer">确认划拨</el-button>
				</el-form-item>
			</el-form>

		</el-col>
		<el-col :span="1">
			<el-button type="primary" style="width:80px;margin-top: 96px;margin-left: 10px" @click.native.prevent="getBusinessInfo">确定</el-button>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				input:"",
				business:{
					account:"",
					id_alias:"",
					phone:"",
					balance:0
				},
				user:{},
				num:"",
				transfer:false
			}
		},
		methods:{
			businessTransfer(){
				let _this = this;
				if(_this.business.account == ""){
					_this.$message({
						message: "请输入账号",
						type: "error"
					});
					return;
				}
				_this.transfer=true;
				let para = {
					account: _this.business.account,
					num: _this.num,
				};
				//NProgress.start();
				_this.$Api.businessTransfer(para).then((res) => {
          _this.$message({
            message: "成功",
            type: 'success'
          });
          _this.$router.push('/transferEnquiry');
					//NProgress.done();
				})
				.catch(err => {
					_this.$message({
						message: err,
						type: "error"
					});
					_this.transfer=false;
				});

			},
			getUserInfo(){
				let _this = this;
				_this.$Api.getUserInfo().then(res => {
          _this.user = res;
				})
				.catch(err => {
					_this.logining = false;
					_this.$message({
						message: err,
						type: "error"
					});
				});
			},
			getBusinessInfo(){
				let _this = this;
				let para = {
					account: _this.input.trim()
				};
				//NProgress.start();
				_this.$Api.getBusinessInfo(para).then((res) => {
          _this.business = res;
					//NProgress.done();
				})
				.catch(err => {
					_this.business = {};
					_this.$message({
						message: err,
						type: "error"
					});
				});
			},
		},
		mounted() {
			this.getUserInfo();
		},
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// transfer.vue?d96f6c5a